import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addMinutes } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import React from 'react';
import { VCS_SLUG } from '../../../constants/api';
import { timezoneOffsetCalculation } from '../../../utils/timezoneOffsetCalculation';
import { PrList } from '../../PullRequestsPage/components/PrList';
import PrMetrics from '../../PullRequestsPage/containers/PrMetrics';
import { BasicInfoTemplate } from './BasicInfoTemplate';
import { CycleTime } from './CycleTime';
import { LoadingMetrics } from './LoadingMetrics';
export const VelocityReportContent = ({ currentNumberOfPRs, previousNumberOfPRs, currentSprint, currentCycleTime, previousCycleTime, datasets, prList, repositories, user, activeRepositoriesIds, from, to, handleRegisterRepo }) => {
    if (!user.user) {
        return _jsx(LoadingMetrics, {});
    }
    const repos = repositories.list[VCS_SLUG[user.user.vcs]] || {};
    const reposSlugs = Object.keys(repos);
    const repositoriesSlugs = Object.assign({}, ...reposSlugs.map((slug) => ({ [repos[slug].id]: slug })));
    let dateFrom, dateTo;
    if (from) {
        dateFrom = addMinutes(toZonedTime(from, 'UTC'), timezoneOffsetCalculation(from, user.user.timezoneId));
    }
    if (to) {
        dateTo = addMinutes(toZonedTime(to, 'UTC'), timezoneOffsetCalculation(to, user.user.timezoneId));
    }
    const basicInfo = {
        previousCycleTime,
        currentCycleTime,
        previousNumberOfPRs,
        currentNumberOfPRs,
    };
    return (_jsxs("div", { className: "velocity", children: [_jsx(BasicInfoTemplate, { basicInfo: basicInfo }), _jsx("hr", {}), _jsx(PrMetrics, { activeRepositoriesIds: activeRepositoriesIds, from: dateFrom, to: dateTo }), _jsx(CycleTime, { currentSprint: currentSprint, previousCycleTime: previousCycleTime, currentCycleTime: currentCycleTime, datasets: datasets }), _jsx(PrList, { pullRequestList: prList, repos: repos, repositoriesSlugs: repositoriesSlugs, onRegisterRepo: handleRegisterRepo, gha: !!user.user?.gha, title: 'Pull Request', loading: false })] }));
};
export default VelocityReportContent;
